import { createFileRoute } from '@tanstack/react-router';
import { PaymentMethodRepairPage } from '@/components/public/PaymentMethodRepairPage';
import type { PublicRecurringBillingRepairContext } from '@/types/public';

export {
  PayabliRepairPanel,
  type PayabliRepairPanelContext,
} from '@/components/public/PaymentMethodRepairPage';

export const Route = createFileRoute('/(public)/repair-payment-method/$token')({
  component: RecurringPaymentMethodRepairPage,
});

function RecurringPaymentMethodRepairPage() {
  const { token } = Route.useParams();
  return (
    <PaymentMethodRepairPage
      token={token}
      apiBase="/api/public/recurring-billing-repair"
      queryKey="recurring-billing-repair"
      describeSubject={(context) => {
        const plan = context as PublicRecurringBillingRepairContext;
        return `recurring billing for ${
          plan.jobNumber ? `${plan.jobNumber} · ${plan.jobName}` : plan.jobName
        }`;
      }}
    />
  );
}
